import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonRegular from './person-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PersonRegular {...validProps} />;
}

SvgComponent.iconName = 'personRegular';

export const PersonRegularIcon = svgIconWrapper(SvgComponent);
